import { openOutlink } from '@utils/schema.js'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'

export const Footer = memo(({ exchanges }) => {
  const { t } = useTranslation()
  const bulletStyle = `relative pl-8 before:bg-navy-500 before:absolute before:top-2 before:left-0 before:h-[3px] before:w-[3px] before:rounded-full before:content-['']`
  return (
    <footer className={'x-spacing text-navy-500 bg-navy-100 min-h-[208px] py-24'}>
      <strong className={'min-h-[20px]'}>{t('footer.title')}</strong>
      <ul className="text-13-regular min-h-[200px] space-y-16 p-8">
        <li className={`${bulletStyle}`}>
          {t('footer.serviceGuide')}
          <div className={'flex'}>
            (
            <div className={'flex gap-4'}>
              {exchanges.map(({ key, labelKey, link }, index) => (
                <button key={key} onClick={() => openOutlink(link)}>
                  <span
                    className={
                      'inline-block border-b border-[#009CDE] pb-0 align-text-bottom leading-none text-[#009CDE]'
                    }
                  >
                    {t(`${labelKey}`)}
                  </span>
                  {exchanges?.length !== index + 1 && <span>,</span>}
                </button>
              ))}
            </div>
            )
          </div>
        </li>
        <li className={`${bulletStyle}`}>{t('footer.investmentNotice')}</li>
        <li className={`${bulletStyle}`}>{t('footer.accuracyNotice')}</li>
        <li className={`${bulletStyle}`}>{t('footer.baseTimeNotice')}</li>
      </ul>
    </footer>
  )
})
